<div class="commonBody background">

  <!-- <img src="{{appiworksLogo}}" class="float floatingimg"/> -->

  <!-- <mat-card> -->
    <guest-section1></guest-section1>
  <!-- </mat-card> -->

  <div fxLayout="row">
    <div fxLayout="column" fxFlex="3"></div>
    <div fxLayout="column" fxFlex="94">
      <br/>
      <mat-card appearance="outlined" class="section">
        <guest-section2></guest-section2>
      </mat-card>
      <br/>
    </div>
    <div fxLayout="column" fxFlex="3"></div>
  </div>

  <div fxLayout="row">
    <div fxLayout="column" fxFlex="3"></div>
    <div fxLayout="column" fxFlex="94">
      <br/>
      <mat-card appearance="outlined" class="section">
        <guest-section3></guest-section3>
      </mat-card>
      <br/>
    </div>
    <div fxLayout="column" fxFlex="3"></div>
  </div>

  <div fxLayout="row" fxHide.xs="true">

    <div fxLayout="column" fxFlex="3"></div>
    <div fxLayout="column" fxFlex="94">

      <mat-card appearance="outlined" class="section">
        <br/>
        <br/>
        <div fxLayout="row"  fxLayoutAlign="center center" class="mat-headline-3 auto_margin"
          style="text-align: center; margin-bottom:20px">
          <b>{{ 'guest.popular_integrations'| translate }}</b>
         </div>

         <div fxLayout="row" fxLayoutAlign="center center" class="mat-h3"
          style="text-align: center; margin-bottom:30px">
          {{ 'guest.popular_integrations_subheading'| translate }}
         </div>
        <guest-section4></guest-section4>
      </mat-card>
      <br/>
    </div>
    <div fxLayout="column" fxFlex="3"></div>
  </div>

  <div fxLayout="row" fxHide.xs="true">

    <div fxLayout="column" fxFlex="3"></div>
    <div fxLayout="column" fxFlex="94">

      <mat-card appearance="outlined" class="section">
        <br/>
        <br/>
        <div fxLayout="row" fxLayoutAlign="center center" class="mat-headline-4 auto_margin"
          style="text-align: center; margin-bottom: 2rem">
          <b>{{ 'guest.product_stats_heading'| translate }}</b>
         </div>

         <div fxLayoutAlign="space-around center" fxLayoutGap=".5rem">
          <div fxFlex="25"><app-score-card [widgetMeta]="productsScorecardConfig"></app-score-card></div>
          <div fxFlex="25"><app-score-card [widgetMeta]="customersScorecardConfig"></app-score-card></div>
          <div fxFlex="25"><app-score-card [widgetMeta]="ratingScorecardConfig"></app-score-card></div>
         </div>

      </mat-card>
      <br/>
    </div>
    <div fxLayout="column" fxFlex="3"></div>
  </div>

  <div class="call_text"> <a style="text-decoration: none;"  routerLink="/bookings" target="_blank">
    Talk to us  <button mat-fab class="call_button">
      <mat-icon>call</mat-icon>
    </button>
  </a>

  </div>

</div>


